import { Modal } from '../../../../../ui/Modal'

const DeleteWarehouseModal = ({ warehouse, isPending = false, onClose, onConfirm }) => (
  <Modal isOpen={!!warehouse} onClose={onClose}>
    <div className='w-[92vw] max-w-md rounded-2xl border border-slate-200 bg-white p-5 shadow-[0_24px_60px_rgba(15,23,42,0.18)]'>
      <div className='mb-4'>
        <p className='text-[11px] font-semibold uppercase tracking-[0.14em] text-accent2'>Inventario</p>
        <h3 className='mt-1 text-lg font-semibold text-text'>Eliminar bodega</h3>
        <p className='mt-2 text-sm leading-5 text-muted'>
          Esta acción desactivará la bodega y dejará de estar disponible en el sistema.
          No podrás eliminar la bodega principal ni una bodega con stock asociado.
        </p>
      </div>

      <div className='rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-700'>
        <span className='font-semibold text-text'>
          {warehouse?.code ?? 'SIN-COD'} · {warehouse?.name ?? 'Sin nombre'}
        </span>
      </div>

      <div className='mt-5 flex justify-end gap-2'>
        <button
          type='button'
          onClick={onClose}
          disabled={isPending}
          className='rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50 disabled:opacity-60'
        >
          Cancelar
        </button>
        <button
          type='button'
          onClick={onConfirm}
          disabled={isPending}
          className='rounded-lg bg-red-600 px-3 py-2 text-sm font-semibold text-white transition hover:bg-red-700 disabled:opacity-60'
        >
          {isPending ? 'Eliminando...' : 'Eliminar'}
        </button>
      </div>
    </div>
  </Modal>
)

export default DeleteWarehouseModal
